import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Loader2, AlertCircle } from 'lucide-react';
import api from '../../services/api';

const PaymentCheckout = () => {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const initiated = useRef(false);

  const quoteId = searchParams.get('quote_id');
  const sig = searchParams.get('sig');
  const hasParams = Boolean(quoteId && sig);

  useEffect(() => {
    if (!hasParams || initiated.current) return;
    initiated.current = true;

    const initiateCheckout = async () => {
      try {
        const res = await api.post('/payment/checkout/create', {
          quote_id: quoteId,
          signature: sig,
          origin_url: window.location.origin
        });

        if (res.data.checkout_url) {
          window.location.href = res.data.checkout_url;
        } else {
          setError("Impossible de créer la session de paiement.");
        }
      } catch (err) {
        const msg = err.response?.data?.detail || "Erreur lors de la redirection vers le paiement.";
        setError(msg);
      }
    };

    initiateCheckout();
  }, [hasParams, quoteId, sig]);

  if (!hasParams) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center px-4">
        <div className="bg-white rounded-xl p-8 border border-red-200 max-w-md w-full text-center">
          <AlertCircle className="h-12 w-12 text-red-500 mx-auto mb-4" />
          <h2 className="text-lg font-semibold text-gray-900 mb-2">{"Erreur de paiement"}</h2>
          <p className="text-sm text-gray-500 mb-6">{"Paramètres de paiement manquants."}</p>
          <button
            onClick={() => navigate('/payment/product')}
            className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors text-sm"
          >
            {"Retour à la formation"}
          </button>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center px-4">
        <div className="bg-white rounded-xl p-8 border border-red-200 max-w-md w-full text-center">
          <AlertCircle className="h-12 w-12 text-red-500 mx-auto mb-4" />
          <h2 className="text-lg font-semibold text-gray-900 mb-2">{"Erreur de paiement"}</h2>
          <p className="text-sm text-gray-500 mb-6">{error}</p>
          <button
            onClick={() => navigate('/payment/product')}
            className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors text-sm"
          >
            {"Retour à la formation"}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="h-12 w-12 text-blue-600 animate-spin mx-auto mb-4" />
        <h2 className="text-lg font-semibold text-gray-900 mb-2">{"Redirection vers le paiement sécurisé..."}</h2>
        <p className="text-sm text-gray-500">{"Vous allez être redirigé vers Stripe."}</p>
      </div>
    </div>
  );
};

export default PaymentCheckout;
